const $accordion = $('.accordion-tabs');
const $section = $accordion.closest('section');
const $accordionHead = $accordion.find('.accordion__head');
const activeClass = 'is-open';

$accordionHead.on('click', function(event) {
  event.preventDefault();

  const $this = $(this);
  const targetId = $this.data('target');
  const $target = $this.closest('section').find(`.accordion__tabs-body .accordion__body[data-id="${targetId}"]`);

  console.log($this);

  $this
    .siblings().slideToggle()
    .parent('.accordion__section').toggleClass(activeClass)
    .siblings('.accordion__section').removeClass(activeClass)
    .find('.accordion__body').slideUp();

  $target
    .addClass(activeClass)
    .siblings().removeClass(activeClass);
});
